// src/shared/set-html.js - v136.8 (reliability audit, 16 Oct 2026).
//
// document.getElementById(x).innerHTML = ... throws "Cannot set properties of null" when the
// element is not on the page (a tab switched away mid-load, a panel the role cannot see, a
// render that lands after its container was replaced). In the admin renders that throw
// aborted the rest of the function, so one missing box blanked or froze the whole panel.
// setHTML writes when the element exists and does nothing when it does not; the render
// carries on. Bundled into each admin module that imports it (zero dependencies).
export function setHTML(id, html) {
  const el = (typeof document !== 'undefined') ? document.getElementById(id) : null;
  if (!el) return false;
  el.innerHTML = html;
  return true;
}
